import {type PublicDialogProps, SelectPickerDialog} from '@github-ui/filter-picker'

import {useDefaultReposProviders} from './hooks/use-query-definitions'
import {getReposItemConfig} from './ItemConfig'
import type {SingleSelectReposProps} from './types'

type SingleSelectReposPickerDialogProps = SingleSelectReposProps & PublicDialogProps

export function SingleSelectReposPickerDialog({scope, ...props}: SingleSelectReposPickerDialogProps) {
  const itemConfig = getReposItemConfig(scope)
  const providers = useDefaultReposProviders(scope)
  const arraySelected = props.selected ? [props.selected] : []

  return (
    <SelectPickerDialog
      {...props}
      title="Select a repository"
      selectionVariant="single"
      selected={arraySelected}
      onSubmit={items => props.onSubmit(items[0])}
      providers={providers}
      itemConfig={itemConfig}
    />
  )
}

try{ SingleSelectReposPickerDialog.displayName ||= 'SingleSelectReposPickerDialog' } catch {}